import { render, staticRenderFns } from "./task-nodes-update.vue?vue&type=template&id=55ebb0f1"
import script from "./task-nodes-update.vue?vue&type=script&lang=js"
export * from "./task-nodes-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports